module.exports = __webpack_public_path__ + "img/hiding-the-map.bc00f007.jpg";